import axios from "../../axios/index.js"

export default {
    addClientToPort(client) {
        return axios.post('/admin/portail/ajoutclient', client, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
    },
    getListLivreurs(

    ) {
        return axios.get('/admin/portail/livreurs', { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } });
    },
    addLivreurToPort(liv) {
        let livreur = {
            name: liv.First_Name,
            no: liv.No,
            type: liv.Type,
            magasin: liv.Responsibility_Center,
            status: liv.Portal_Status

        }
        return axios.post('/admin/portail/ajoutLivreurs', livreur, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
    },
    getMobileApp() {
        return axios.get('/admin/portail/download/livreurapp', { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } });
    },
    getNbreCommandePoratilMois() {
        return axios.get('/admin/portail/statistique/commande/parportail', { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } });
    },
    getNbreCommandePortailTotal() {

        return axios.get('/admin/portail/statistique/commande/nombretotal', { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } });
    },
    addAdminToPortail(admin){
        return axios.post('/admin/portail/adminCompte', admin, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
    } ,
    getListAdmin(){
        return axios.get('/admin/portail/adminCompte', { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } });
    },
    getListeRolesAdmin(){
        return axios.get('/admin/portail/adminCompte/roles', { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } });
    }
}
